import React from 'react'

const React_Coding_Practice_36 = () => {
  return (
    <div>
      <h1>Coding Pratice 36</h1>
    </div>
  )
}

export default React_Coding_Practice_36
